module.exports = __webpack_public_path__ + "static/img/zaozhuang3.e7cec440.jpg";